import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ProjetIndicateur } from 'src/app/shared/models/projet';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { DetailTepActiviteOpComponent } from '../detail-tep-activite/detail-tep-activite-op.component';

@Component({
  selector: 'app-budget-by-programme',
  standalone: false,
  templateUrl: './budget-by-programme.component.html',
  styleUrl: './budget-by-programme.component.scss'
})

export class BudgetByProgrammeComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  projetData: any = [] = [];
  annee: any;
  modalRef: NgbModalRef | null = null;
  isLoading: boolean = false;
  searchTerm: string = '';

  itemToDelete!: ProjetIndicateur;
  filteredtems: any = [];
  projetId: any
  pageSize: number = 10;
  pdfUrl: string;
  excelUrl: string;

  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  paginatedProjets: any = [];

  projetItems: any = [];
  selectedProjet: any;
  directionId: any;
  showFiltre: boolean = false;
  directionItems: any = [];
  userInfo: any
  dateDebut: string;
  dateFin: string;

  // Chart configuration
  barChartData: any;
  barChartOptions: any;

  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {

  }

  ngOnInit(): void {

    // Initialize chart options
    this.barChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value: number) => this.formatMoney(value)
          },
          title: {
            display: true,
            text: 'Budget Total'
          }
        },
        x: {
          title: {
            display: true,
            text: 'Programmes'
          }
        }
      },
      plugins: {
        legend: {
          display: true,
          position: 'top'
        },
        tooltip: {
          callbacks: {
            label: (context: any) => {
              return context.dataset.label + ': ' + this.formatMoney(context.raw);
            }
          }
        }
      }
    };

    this.projetId = this.localstorage.getProjetToUser();
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    this.userInfo = this.localstorage.getInfoUserToService();


    this.dateDebut = `${this.annee}-01-01`;
    this.dateFin = `${this.annee}-12-31`;

    if (this.userInfo?.data?.groupe === "admin") {

      this.showFiltre = true;
      this.getDirection();
    }
    if (this.userInfo?.data?.groupe === "point_focal") {

      this.directionId = this.localstorage.getInfoUserToService()?.data?.direction_id;
      this.getProjetByDirection(this.directionId);
    }

    //
    this.getStatistiqueBudgetaires();
  }

  formatMoney(value: number): string {
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + 'K';
    }
    return value.toString();
  }


  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }
  getProjetByDirection(reference: any) {
    this.paramservice.getProjetByDirection(reference).subscribe(
      (response: any) => {
        this.projetItems = response.data;
        // this.getExercice();
        //////console.log("la reponse du webservice", this.projetItems);
      },
      (error: any) => {
        ////console.log("une erreur est survenu", error);
      }
    )
  }//end getProjetByDirection

  //statistiques activites budgetaires
  getStatistiqueBudgetaires() {
    //check
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    let projectItem: any = {};
    if (this.selectedProjet === "DEFAULT") {
      projectItem = null;
    } else {
      projectItem = this.selectedProjet;
    }

    this.isLoading = true;
    this.ngxService.start();
    this.paramservice.getStatistiqueTepActiviteBudgetaire(this.annee, projectItem, this.directionId, this.dateDebut, this.dateFin, this.userInfo?.data?.reference).subscribe(
      (response: any) => {
        this.ngxService.stop();
        this.isLoading = false;
        this.projetData = response.data;
        this.totalRecords = this.projetData.length;
        this.updatePaginatedProjets();
        this.updateBarChart();
      },
      (error) => {
        this.ngxService.stop();
        this.isLoading = false;
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
        ////console.log('une erreur est survenue', error);
      }
    );
  }//end getStatistiqueBudgetaires

  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.projetData.slice(start, end);
  }

  //export as document
  //   exportToDocument(typeDoc: any) {
  //     //check
  //     if(this.dateDebut === null || this.dateDebut === undefined){
  //       this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
  //       return;
  //     }
  //     if(this.dateFin === null || this.dateFin === undefined){
  //       this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
  //       return;
  //     }
  //     let projectItem: any = {};
  //     if(this.selectedProjet === "DEFAULT"){
  //       projectItem = null;
  //     }else{
  //       projectItem = this.selectedProjet;
  //     }

  // this.ngxService.start();

  // this.paramservice.printStatistiqueTepBudgetaireAsFile(this.annee, projectItem, this.directionId, this.dateDebut, this.dateFin, typeDoc, this.userInfo?.data?.reference ).subscribe(
  //   (response: Blob) => {
  //     const filename = 'Statistiques_Activite_Operationnelle.pdf';
  //     FileSaver.saveAs(response, filename);

  //     const url = URL.createObjectURL(response);
  //     window.open(url, '_blank');

  //     this.ngxService.stop();
  //     this.messageService.add({ severity: 'success', summary: 'Téléchargement', detail: 'Le fichier a été téléchargé avec succès', life: 3000 });
  //   },
  //   (error) => {
  //     this.ngxService.stop();
  //     this.messageService.add({ severity: 'error', summary: 'Téléchargement', detail: error, life: 3000 });
  //   }
  // );
  // }//end export



  exportToDocument(typeDoc: string): void {
    // Validation des dates
    if (!this.dateDebut) {
      this.messageService.add({
        severity: 'error',
        summary: 'TEP',
        detail: 'Veuillez renseigner la date de début',
        life: 3000
      });
      return;
    }

    if (!this.dateFin) {
      this.messageService.add({
        severity: 'error',
        summary: 'TEP',
        detail: 'Veuillez renseigner la date de fin',
        life: 3000
      });
      return;
    }

    // Gestion du projet
    const projectItem = this.selectedProjet === "DEFAULT" ? null : this.selectedProjet;

    this.ngxService.start();

    this.paramservice.printStatistiqueTepBudgetaireAsFile(
      this.annee,
      projectItem,
      this.directionId,
      this.dateDebut,
      this.dateFin,
      typeDoc,
      this.userInfo?.data?.reference
    ).subscribe({
      next: (response: Blob) => {
        const filename = this.getFilename(typeDoc);
        const url = URL.createObjectURL(response);

        // Téléchargement automatique
        FileSaver.saveAs(response, filename);

        // Ouverture dans un nouvel onglet
        //  window.open(url, '_blank');

        this.ngxService.stop();
        this.messageService.add({
          severity: 'success',
          summary: 'Téléchargement',
          detail: 'Le fichier a été téléchargé avec succès',
          life: 3000
        });
      },
      error: (error: any) => {
        this.ngxService.stop();
        // const errorMessage = this.getErrorMessage(error);
        this.messageService.add({
          severity: 'error',
          summary: 'Téléchargement',
          detail: "une erreur est survenu",
          life: 3000
        });
      }
    });
  }

  private getFilename(typeDoc: string): string {
    const extension = typeDoc === 'pdf' ? 'pdf' : 'xlsx';
    return `budget par programme.${extension}`;
  }

  updateBarChart(): void {
    if (this.projetData.length > 0) {
      const labels = this.projetData.map((item: any) =>
        item?.programme?.libelle || item?.programme?.code || 'N/A'
      );

      const budgets = this.projetData.map((item: any) => item?.montant_total || 0);

      this.barChartData = {
        labels: labels,
        datasets: [
          {
            label: 'Budget Total par Programme',
            backgroundColor: '#66bdcb',
            data: budgets
          }
        ]
      };
    } else {
      this.barChartData = {
        labels: [],
        datasets: [
          {
            label: 'Budget Total par Programme',
            backgroundColor: '#66bdcb',
            data: []
          }
        ]
      };
    }
  }

}
